import { render, staticRenderFns } from "./EnvelopeTemplateList.vue?vue&type=template&id=021c062a&scoped=true"
import script from "./EnvelopeTemplateList.vue?vue&type=script&lang=js"
export * from "./EnvelopeTemplateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021c062a",
  null
  
)

export default component.exports